// The negligence filter is sent as the strings 'true'/'false' (Spring binds them to Boolean). Booleans would
// not survive the store's falsy cleanup: "without negligence" (false) would be dropped as if no filter was set.
export const NEGLIGENCE_FILTER_VALUES = ['true', 'false']

export function negligenceFilterOptions(i18n) {
  return [
    { name: i18n('dispute.filters.withNegligence'), value: 'true' },
    { name: i18n('dispute.filters.withoutNegligence'), value: 'false' },
  ]
}

export function removeEmptyNegligenceParam(params) {
  if (!NEGLIGENCE_FILTER_VALUES.includes(params.negligence)) delete params.negligence
  return params
}

// Negligence only exists on objections (contestações): it comes from the reason chosen when an item is approved.
export function showsNegligenceCount(item, isAdmin) {
  return isAdmin && item?.type === 'OBJECTION'
}
